export default __webpack_public_path__ + "static/media/screen4.e5f96572.png";